import {BaseService} from './baseService.js';

/* 
 * Handles interaction with the account management api
 */
export class AccountManagementService extends BaseService {
	
	constructor() {	
		super();
	}
	
	async getManagedAccounts(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		var props = await this.makeGETRequest('/api/service/account-management/accounts' + params);		
		return props;		
	}

	exportManagedAccounts(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		this.downloadFile('/api/service/account-management/accounts/export' + params);
	}
	
	async getManagedCompanies() {
		var props = await this.makeGETRequest('/api/service/account-management/companies');		
		return props;		
	}
	
}

